import {
    GET_ALL_MANIFEST_PRODUCTS,
    GET_SINGLE_MANIFEST,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
} from './manifestTypes'

export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_ALL_MANIFEST_PRODUCTS:
            return {
                ...state,
                all_manifest_products: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        case GET_SINGLE_MANIFEST:
            return {
                ...state,
                single_manifest: action.payload,
            }
        default:
            return state
    }
}
